<footer class="main-footer">
  <div class="container text-center">
    <strong>Powered By OEG</strong>
  </div>

  
</footer>


